<template>
    <div>
        <div id="auth-layout" class="layout">
            <nav-bar :user-logged-in="userLoggedIn"></nav-bar>

            <div id="content-area" class="container d-flex justify-content-center mt-5">
                <slot></slot>
            </div>

            <component :is="getFooterComponent()"></component>
        </div>

        <cookie-consent-box></cookie-consent-box>
    </div>
</template>

<script>
import Vue from "vue";
import NavBar from '../components/organisms/NavBar'
import FooterBar from '../components/organisms/FooterBar.vue'
import FooterBarCanada from '../components/organisms/FooterBarCanada.vue'
import CookieConsentBox from "../components/molecules/CookieConsentBox.vue";

export default Vue.extend({
    components: {
        NavBar, FooterBar, FooterBarCanada,
        CookieConsentBox
    },
    methods: {
        getFooterComponent() {
            return this.$root.whitelabel.getFooterLayout();
        }

    },
    computed: {
        userLoggedIn() {
            return this.$root.user.isLoggedIn()
        }
    },
    head: {
        link: function () {
            return [
                { r: 'icon', h: this.$root.whitelabel.buildFaviconUrl(16), sz: '16x16', t: 'image/png' },
                { r: 'icon', h: this.$root.whitelabel.buildFaviconUrl(32), sz: '32x32', t: 'image/png' },
                { r: 'icon', h: this.$root.whitelabel.buildFaviconUrl(150), sz: '150x150', t: 'image/png' },
                { r: 'icon', h: this.$root.whitelabel.buildFaviconUrl(192), sz: '192x192', t: 'image/png' },
            ]
        }
    }
})
</script>
